import React from "react";
import live from "../../assets/svg/planerpage/live.svg";
import page from "../../assets/svg/planerpage/gridicons_pages.svg";
import group from "../../assets/svg/planerpage/Group.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useDispatch } from "react-redux";
import { setSelectedEventsDetails } from "../../store/auth/auth.slice";
import { ROUTES } from "../../constants/routes";
import { useAnalytics } from "../../contexts/AnalyticsContext";

import configJson from "../../constants/question_paper_mapping_prod.json";

export const EventCardShort = ({ data }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const analytics = useAnalytics();

  const redirectToEvent = () => {
    analytics.trackTakeTestClicked(data.exam_id);
    dispatch(setSelectedEventsDetails(data));
    history.push(ROUTES.EXAMPAGE);
  };

  const roundData = configJson?.[data.event_code]?.[data.level]?.[data.round];
  let eventConfig = null;
  if (roundData) {
    for (let key in roundData) {
      const testConfig = roundData[key][data.examType];
      if (
        testConfig &&
        Object.prototype.hasOwnProperty.call(testConfig, "question_paper_id") &&
        testConfig.question_paper_id === data.qu_id
      ) {
        eventConfig = testConfig;
        break;
      }
    }
  }

  const noQuestions = eventConfig?.total_question;

  const getButtonText = () => {
    const examStatus = data?.is_exam_status;

    if (examStatus === "COMPLETED") {
      return "View Report & Certificate";
    }

    if (examStatus === "NOT_STARTED") {
      return "Take Test";
    }

    if (examStatus === "STARTED" || examStatus === "INITIATED") {
      if (data?.can_resume_exam === true) {
        return "Take Test";
      } else {
        return "View Report & Certificate";
      }
    }

    return "Take Test";
  };

  const buttonText = getButtonText();
  const showLiveStatus = buttonText === "Take Test";

  return (
    <div className="Planer-evnt-card">
      <div className="pl_card-header-cont">
        <div className="pl_exam-title">
          {data.title} {["semi-finals", "finals"].includes(data.level?.toLowerCase()) ? "" : data.level}
        </div>
        {showLiveStatus && (
          <div className="pl_status-cont">
            <span>
              <img className="pl_live-img" src={live} alt="Live Icon" />
            </span>
            Live
          </div>
        )}
      </div>
      <div className="pl_card-header-cont">
        <p className="pl_card-details">
          <span style={{ fontWeight: "700" }}>Grade -</span>
          {data.grade_id}
        </p>

        {noQuestions && (
          <p className="pl_card-details">
            <span>
              <img src={page} alt="Page Icon" />
            </span>
            {noQuestions} Questions
          </p>
        )}
      </div>
      <div className="pl_group-info">
        <span>
          <img className="pl_live-img" src={group} alt="Group Icon" />
        </span>
        <span className="pl_group-text">+90.7k attempted from your city</span>
      </div>

      <button onClick={redirectToEvent} className="pl_test-cta">
        {buttonText}
      </button>
    </div>
  );
};
